

exports.__esModule = true;
exports.$xoPageAddCardPageComponent = undefined;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _factory = require('xo-member-components/src/no-balance/factory');

var _factory2 = require('xo-wallet-components/src/add-card/addcard/factory');

var _auth = require('xo-models/src/auth');

var _fi = require('xo-models/src/fi');

var _choice = require('xo-models/src/choice');

var _app = require('xo-models/src/app');

var _fiMessages = require('xo-models/src/fi/lib/fiMessages');

var _index = require('xo-models/src/fiMeta/index');

var _index2 = _interopRequireDefault(_index);

var _newMember = require('xo-models/src/newMember');

var _checkoutIncentive = require('xo-models/src/checkoutIncentive');

var _checkout = require('xo-models/src/checkout');

require('xo-page-components/src/notYou/directive');

require('xo-page-components/src/value-props/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/modal/directive');

require('xo-ui-components/src/tooltip/directive');

require('xo-validation/dist/directive');

require('xo-wallet-components/src/add-card/directive');

require('xo-member-components/src/no-balance/directive');

var _factory3 = require('xo-ui-components/src/expired-fi-panel/factory');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _sharedUtil = require('../services/shared-util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var disallowedExp = _factory3.$ExpiredFiPanelFactory.disallowedExp;
var $xoPageAddCardPageComponent = exports.$xoPageAddCardPageComponent = _squid.$Component.extend('$xoPageAddCardPageComponent', {
    tag: 'xo-page-add-card-page',
    template: _template2['default'],
    scope: {},
    controller: ['$scope', function ($scope) {
        if (_uiRouter.$stateParams.cause === 'cpa') {
            $scope.cause = _uiRouter.$stateParams.cause;
        }
        $scope.locale = _squid.$locale;
        $scope.token = _angular.$rootScope.token;
        $scope.showIncentive = false; // Assume we won't show an incentive
        $scope.isProcessorDeclineExperiment = false;
        $scope.logSubscriptionEvent = _sharedUtil.$SharedUtil.logSubscriptionEvent(_angular.$rootScope && _angular.$rootScope.token);
        $scope.logSubscriptionEvent({
            from: 'add_card_rendered',
            to: 'prepare_add_card'
        });
        var models = {};

        $scope.callbacks = {
            finish: function finish() {
                $scope.logSubscriptionEvent({
                    from: 'add_card_completed',
                    to: 'process_add_card'
                });
                if (models.cart.isWalletTokenization() && models.walletPinModel.isSetupEligible()) {
                    _logger.$logger.debug('pinSetup_required');
                    _uiRouter.$state.go('checkout.pinSetup');
                } else {
                    _uiRouter.$state.go('checkout.review');
                }
            },
            cancel: function cancel(routeTo) {
                $scope.logSubscriptionEvent({
                    from: 'add_card_cancelled',
                    to: 'process_add_card'
                });
                var goTo = routeTo || $scope.parentState || '';

                _logger.$logger.debug('xoAddCard_cancel', { goTo: goTo });
                if (goTo) {
                    _uiRouter.$state.go(goTo);
                }
            }
        };

        (0, _squid.$populate)(models, {
            checkoutSession: _checkout.$CheckoutSessionModel.instance($scope.token).retrieve({
                contingencies: {
                    NEED_CREDIT_CARD: angular.noop,
                    EXPIRED_CREDIT_CARD: angular.noop,
                    NEED_DEBIT_CARD: angular.noop,
                    EXPIRED_DEBIT_CARD: angular.noop
                }
            }),
            unavailableCard: _fi.$UnavailableCardModel.instance(),
            payee: _checkout.$CheckoutPayeeModel.instance($scope.token),
            cart: _checkout.$CheckoutCartModel.instance($scope.token),
            auth: _auth.$AuthModel.instance().retrieve(),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance($scope.token).retrieve(),
            noBalanceFactoryState: _factory.$NoBalanceFactory.decideEligibility(),
            fiMeta: _index2['default'].instance(_angular.$rootScope.token).fetch()['catch'](_angular.noop)
        }).then(function () {
            $scope.PPBalanceFlow = _sharedUtil.$SharedUtil.isPPCashToBalanceEnabled(_squid.$locale);
            $scope.noBalanceFactoryState = _factory.$NoBalanceFactory.get();
            // Resolve additional information needed
            var getWalletPinModel = function getWalletPinModel() {
                if (models.cart.isWalletTokenization()) {
                    return (0, _squid.$populate)(models, {
                        walletPinModel: _app.$TokenizedWalletPinModel.instance($scope.token)
                    });
                }
            };

            var getCheckoutIncentiveEligibility = function getCheckoutIncentiveEligibility() {
                return (0, _angular.$q)(function (resolve, reject) {
                    var fptiData = {
                        from: 'FI_addCardAccount',
                        to: 'prepare_FI_addCardAccount',
                        context_id: $scope.token,
                        eligibility_reason: ''
                    };

                    if (models.cart.isWalletTokenization()) {
                        fptiData.eligibility_reason = 'Incentive_Ineligible_Wallet_Tokenization';
                        _logger.$logger.info('checkout_fpti', fptiData);
                        return resolve(false);
                    }

                    if (models.payee.isGambling()) {
                        fptiData.eligibility_reason = 'Incentive_Ineligible_Gambling_Merchant';
                        _logger.$logger.info('checkout_fpti', fptiData);
                        return resolve(false);
                    }

                    var country_code = _squid.$locale.getCountryCodeISO();

                    var offerEligibilityData = {
                        payer_id: models.auth.buyer_id,
                        country_code: country_code,
                        language: _squid.$locale.getLocaleCode(),
                        touchpoint_code: 'CHECKOUT_INCENTIVE' // TODO don't hardcode this?
                    };

                    $scope.evaluateCheckoutOfferEligibilityModel = _checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel.instance();

                    $scope.evaluateCheckoutOfferEligibilityModel.save({
                        data: offerEligibilityData,
                        success: function success() {

                            if (!$scope.evaluateCheckoutOfferEligibilityModel.isEligible()) {
                                fptiData.eligibility_reason = 'Incentive_Ineligible_Not_In_MORS_Segment';
                                _logger.$logger.info('checkout_fpti', fptiData);
                                return resolve(false);
                            }

                            $scope.getOfferProgramModel = _checkoutIncentive.$GetOfferProgramModel.instance();
                            var offer_program_code = $scope.evaluateCheckoutOfferEligibilityModel.getOfferProgramCode();

                            $scope.getOfferProgramModel.retrieve({
                                params: { offer_program_code: offer_program_code },
                                success: function success() {
                                    var offerCurrencyCode = $scope.getOfferProgramModel.getOfferCurrencyCode();
                                    var cartCurrencyCode = models.cart.getCartCurrencyCode();

                                    if (cartCurrencyCode !== offerCurrencyCode) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_Cart_Currency_Not_Offer_Currency';
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }

                                    var txnMinimumLowestDenom = $scope.getOfferProgramModel.getMinCartTotalLowestDenom();
                                    var precisionDigits = _squid.$locale.metadata.currency.digits[offerCurrencyCode];
                                    var txnMinimum = txnMinimumLowestDenom;

                                    if (precisionDigits) {
                                        txnMinimum = (txnMinimumLowestDenom / Math.pow(10, precisionDigits)).toFixed(precisionDigits);
                                    }

                                    var txnAmt = models.cart.getPurchaseAmount();
                                    var isTxnWorthEnough = txnAmt >= txnMinimum;

                                    if (!isTxnWorthEnough) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_Transaction_Not_Worth_Enough';
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }

                                    var isUserInApplicableCountry = $scope.getOfferProgramModel.isUserInApplicableCountry(country_code);

                                    if (!isUserInApplicableCountry) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_Country_Ineligible';
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }

                                    fptiData.eligibility_reason = 'Incentive_Eligible';
                                    _logger.$logger.info('checkout_fpti', fptiData);

                                    var pxpFptiData = {
                                        state_name: 'FI_addCardAccount',
                                        transition_name: 'prepare_FI_addCardAccount_incentive',
                                        incentive_name: ''
                                    };

                                    return _factory2.$AddCardFactory.getCheckoutIncentivePxpResult().then(function (result) {
                                        if (result === 'xo_hermes_checkout_incentive_show') {
                                            pxpFptiData.incentive_name = $scope.getOfferProgramModel.offer_program_code;
                                            _logger.$logger.info('checkout_fpti', pxpFptiData);
                                            return resolve(true);
                                        }

                                        _logger.$logger.info('checkout_fpti', pxpFptiData);
                                        return resolve(false);
                                    })['catch'](function () {
                                        _logger.$logger.info('checkout_fpti', pxpFptiData);
                                        return resolve(false);
                                    });
                                },
                                contingencies: {
                                    DEFAULT: function DEFAULT(msg, contingency) {
                                        fptiData.eligibility_reason = 'Incentive_Ineligible_' + msg;
                                        _logger.$logger.info('checkout_fpti', fptiData);
                                        return resolve(false);
                                    }
                                },
                                error: function error() {
                                    fptiData.eligibility_reason = 'Get_Program_Error';
                                    _logger.$logger.info('checkout_fpti', fptiData);
                                    return resolve(false);
                                }
                            });
                        },
                        contingencies: {
                            DEFAULT: function DEFAULT(msg, contingency) {
                                fptiData.eligibility_reason = 'Incentive_Ineligible_' + msg;
                                _logger.$logger.info('checkout_fpti', fptiData);
                                return resolve(false);
                            }
                        },
                        error: function error() {
                            fptiData.eligibility_reason = 'MORS_Error';
                            _logger.$logger.info('checkout_fpti', fptiData);
                            return resolve(false);
                        }
                    });
                });
            };

            var getHideControlMsg = function getHideControlMsg() {
                return _newMember.$NewMemberEligibility.instance().isNmj($scope.token);
            };

            var getSelectFiVariant = function getSelectFiVariant() {
                return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                    var selectFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.selectFi || [];

                    if (selectFiVariants.indexOf(variant) !== -1) {
                        return true;
                    }

                    return false;
                });
            };

            var subscriptionAuRMG = function subscriptionAuRMG() {
                return (0, _squid.$elmo)('xo_hermes_au_rmg_msg', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_au_rmg_msg').then(function (result) {
                    return { enabled: Boolean(result && result.treatment_name) };
                });
            };

            var shouldShowPendingBalance = function shouldShowPendingBalance() {
                return (0, _squid.$elmo)('xo_hermes_no_balance_text', { 'ctx.COUNTRY': _squid.$locale.country }, 'Trmt_xo_hermes_no_balance_text').then(function (result) {
                    return { enabled: Boolean(result && result.treatment_name) };
                });
            };
            shouldShowPendingBalance().then(function (result) {
                if (result.enabled === true) {
                    _logger.$logger.info('claim_balance_text_not_allowed_to_be_shown_elmo');
                    $scope.shouldShowPendingBalance = false;
                } else {
                    _logger.$logger.info('claim_balance_text_allowed_to_be_shown_elmo');
                    $scope.shouldShowPendingBalance = true;
                }
            });

            // Return the reason for disallowed in the wallet, due to preauth or bank
            var checkDeclineReason = function checkDeclineReason() {
                var disallowedInstruments = models.checkoutSession.get('fundingOptions').get('disallowedInstruments');
                var disallowedPreAuth = _squid.$util.filter(disallowedInstruments, function (instrument) {
                    return instrument.declineReason === 'INSTRUMENT_VERIFICATION_FAILED';
                });

                if (!disallowedInstruments) {
                    return;
                }

                if (disallowedPreAuth && disallowedPreAuth.length > 0) {
                    return 'PREAUTH';
                }

                var disallowedNonBankInstruments = _squid.$util.filter(disallowedInstruments, function (disallowedInstrument) {
                    return disallowedInstrument.type !== 'BANK';
                });

                if (disallowedNonBankInstruments && disallowedNonBankInstruments.length >= 1) {
                    return;
                }

                return 'BANK';
            };

            var checkProcessorDeclineIssuerExperiment = function checkProcessorDeclineIssuerExperiment() {
                var declinedInstruments = models.checkoutSession.get('declinedInstruments', []);
                if (declinedInstruments && declinedInstruments.length > 0) {
                    return _factory2.$AddCardFactory.getIssuerDeclineElmoResult();
                }
                return '';
            };

            var getInformalName = function getInformalName() {
                var formattedNameInformal = void 0;
                if (models.auth) {
                    formattedNameInformal = (0, _squid.formatNameInformal)({
                        first_name: models.auth.first_name,
                        last_name: models.auth.last_name
                    }) || models.auth.email;
                }
                return formattedNameInformal;
            };

            $scope.isCPAEligible = _sharedUtil.$SharedUtil.isAuthDeclinedInstrument(models.checkoutSession) || _sharedUtil.$SharedUtil.isAuthRequiredInAnyFI(models.checkoutSession);

            return _squid.$promise.hash({
                walletPinModel: getWalletPinModel(),
                hideControlMsg: getHideControlMsg(),
                checkoutIncentiveEligibility: getCheckoutIncentiveEligibility(),
                selectFiVariant: getSelectFiVariant(),
                checkDeclineReason: checkDeclineReason(),
                addCardContingency: _factory3.$ExpiredFiPanelFactory.getPxpResult(models),
                issuerDeclineTreatment: checkProcessorDeclineIssuerExperiment(),
                formattedNameInformal: getInformalName(),
                subscriptionAuRMGElmoResult: subscriptionAuRMG()

            });
        }).then(function (_ref) {
            var hideControlMsg = _ref.hideControlMsg,
                selectFiVariant = _ref.selectFiVariant,
                checkDeclineReason = _ref.checkDeclineReason,
                checkoutIncentiveEligibility = _ref.checkoutIncentiveEligibility,
                addCardContingency = _ref.addCardContingency,
                issuerDeclineTreatment = _ref.issuerDeclineTreatment,
                formattedNameInformal = _ref.formattedNameInformal,
                subscriptionAuRMGElmoResult = _ref.subscriptionAuRMGElmoResult;


            var message = void 0;

            // smartDollarAuthFailed is true when smart $x auth check fails on 'authorize'
            if (models.checkoutSession.smartDollarAuthFailed) {
                message = {
                    type: 'error',
                    msg: (0, _squid.$renderContent)('payment.authFailureSingleFI')
                };
            } else {
                if (issuerDeclineTreatment === 'Trmt_xo_hermesnodeweb_issuer_decline_1') {
                    $scope.isProcessorDeclineExperiment = true;
                }
                message = _fiMessages.$fiMessages.processorDeclinedMsg(models.checkoutSession, false, issuerDeclineTreatment, models.auth, models.fiMeta.wallet, formattedNameInformal);
            }

            var isCreditDisallowedForMerchant = models.checkoutSession.isCreditDisallowedForMerchant;
            if (isCreditDisallowedForMerchant) {
                $scope.creditDisallowedMessage = {
                    type: 'warning',
                    msgs: [_squid.$locale.content.get('addCard.creditCardNotAllowed')]
                };
            }

            var isGamblingMerchant = models.payee.isGambling();
            if (isGamblingMerchant && subscriptionAuRMGElmoResult.enabled === true) {
                _logger.$logger.info('credit_card_not_allowed_RMG', { country: _squid.$locale.country });
                $scope.gamblingMessage = {
                    type: 'warning',
                    msgs: [_squid.$locale.content.get('addCard.creditCardNotAllowed')]
                };
            }

            var redirectFromXoon = _squid.$util.param('redirectToHermes') ? true : false;
            var retry = _squid.$util.param('addFIContingency') === 'retry' ? true : false;
            var avsRetry = _squid.$util.param('avsRetry') ? true : false;

            var getContingencyDeclineMessage = function getContingencyDeclineMessage(declineReason, _ref2) {
                var disallowedInstruments = _ref2.disallowedInstruments;

                switch (declineReason) {
                    case 'BANK':
                        message = _fiMessages.$fiMessages.getAddBankTreatmentMsg();
                        break;
                    case 'PREAUTH':
                        var disallowed = _squid.$util.filter(disallowedInstruments, function (instrument) {
                            return instrument.declineReason === 'INSTRUMENT_VERIFICATION_FAILED';
                        });

                        message = _fiMessages.$fiMessages.getPreAuthTreatmentMsg(disallowed);
                        break;
                    default:
                        message = _fiMessages.$fiMessages.getAddCardTreatmentMsg(models.checkoutSession);
                        break;
                }
            };
            // If no processor decline, get the message when contingency is anything but NEED_DEBIT_CARD
            if (!message && models.checkoutSession.get('errorData.cause') && _uiRouter.$stateParams.message !== 'NEED_DEBIT_CARD' && !(subscriptionAuRMGElmoResult.enabled === true && isGamblingMerchant)) {
                if (models.payee.isGambling()) {
                    message = _fiMessages.$fiMessages.getGamblingMsg();
                } else if (!hideControlMsg && addCardContingency && (addCardContingency === disallowedExp.disallowedFi || addCardContingency === disallowedExp.preAuth)) {
                    getContingencyDeclineMessage(checkDeclineReason, models.checkoutSession.get('fundingOptions'));
                } else {
                    message = _fiMessages.$fiMessages.getAddCardMsg(models.unavailableCard, { retry: retry, avsRetry: avsRetry, redirectFromXoon: redirectFromXoon }, models.checkoutSession);
                    var noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.noBillingFIContingency');

                    // Content changes for change card for indian billing start
                    if (models.cart.isConsumerCountry('IN') && models.cart.isBilling()) {
                        if (models.cart.isRecurringPayment() || models.checkoutAppData.is_wps_flow()) {
                            noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.not.immediate.noBillingFIContingency');
                        } else if (models.cart.isReferenceTransaction()) {

                            if (models.checkoutAppData.isMerchantCountry('IN')) {
                                if (models.cart.isChargePatternImmediateOrDeferred()) {
                                    noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.immediate.noBillingFIContingency');
                                } else {
                                    noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.not.immediate.noBillingFIContingency');
                                }
                            } else {
                                noBillingFIContingencyIndia = (0, _squid.$renderContent)('creditcard.not.immediate.noBillingFIContingency');
                            }
                        }
                    }
                    // Content changes for change card for indian billing end

                    if (models.cart.isBilling() && noBillingFIContingencyIndia && _squid.$locale.country === 'IN') {
                        message.msg = noBillingFIContingencyIndia;
                        message.type = 'info';
                    }
                }
            }

            function checkFor3DSDeclineMessage() {
                // extract card information from 3DS V1 contingency context
                var checkoutSession = models.checkoutSession;

                // if no checkoutSession exit early
                if (!checkoutSession) {
                    return;
                }

                // extract card information for 3DS V1 contingency
                var card = checkoutSession.resolve_3ds;
                var threeDSResolutionData = checkoutSession.threeDSResolutionData;

                // if no 3DS information exit early
                if (!card && !threeDSResolutionData) {
                    return;
                }

                // extract card information from 3DS V2 contingency context

                var _ref3 = threeDSResolutionData.resolutions || [],
                    resolutions = _ref3[0];

                var _ref4 = resolutions || {},
                    _ref4$funding_instrum = _ref4.funding_instrument_details;

                _ref4$funding_instrum = _ref4$funding_instrum === undefined ? {} : _ref4$funding_instrum;
                var _ref4$funding_instrum2 = _ref4$funding_instrum.payment_card,
                    payment_card = _ref4$funding_instrum2 === undefined ? {} : _ref4$funding_instrum2;

                // consider V1 or V2 card data

                var cardInformation = card || payment_card;

                if (cardInformation) {
                    message = {
                        msg: (0, _squid.$renderContent)('threeDS.memberDeclineAfter3DSAcceptNoFI', {
                            cardType: cardInformation.type,
                            last4: cardInformation.number
                        }),
                        type: 'warning'
                    };
                }
            }

            function isUSCrossCurrency() {
                if (models.cart && models.cart.grossTotalAmount && models.cart.get('grossTotalAmount.currency') !== 'USD' && _squid.$locale.country === 'US') {
                    return true;
                }
                return false;
            }

            function checkAvailableFI() {
                if (isUSCrossCurrency()) {
                    var plans = models.checkoutSession.fundingOptions.plans.filter(function (plan) {
                        return plan.primaryFs.name !== 'BILL_ME_LATER';
                    });
                    if (plans.length > 1) {
                        return true;
                    }
                    return false;
                } else {
                    if (models.checkoutSession.fundingOptions.plans && models.checkoutSession.fundingOptions.plans.length > 1) {
                        return true;
                    }
                    return false;
                }
            }

            /**
             * if we get add card contingency after we try to clear three ds contingency
             * check if we have add card contingency along with threeDSResolutionData to display
             * error message
             */
            // make sure we dont have any other message set in scope
            if (!message) {
                if (_uiRouter.$stateParams.message === 'NEED_CREDIT_CARD') {
                    checkFor3DSDeclineMessage();
                }
            }

            if (message) {
                $scope.logSubscriptionEvent({
                    from: 'add_card_contingency',
                    to: 'process_add_card',
                    message: message
                });
                $scope.message = {
                    type: message.type,
                    msgs: [message.msg]
                };
                if (message.title) {
                    $scope.messagetitle = _squid.$locale.content.get(message.title.key);
                }
            }
            // Reset the message if it is CPA flow for single FI contingency.
            if ($scope.cause === 'cpa' && _uiRouter.$stateParams.message === 'NEED_CREDIT_CARD' || $scope.isCPAEligible) {
                $scope.message = null;
                $scope.messagetitle = null;
            }

            $scope.cart = models.cart;
            $scope.auth = models.auth;

            // Show this message if this is the first page the user sees (these cases usually have a message).
            // Do not show if entering from another page, like the select-fi page
            if (!hideControlMsg) {
                $scope.showHiMsg = message || !selectFiVariant;
                $scope.showNotYou = $scope.auth && $scope.auth.showNotYou();
            }

            // Render the incentive banner if eligible
            $scope.showIncentive = checkoutIncentiveEligibility;

            if ($scope.showIncentive) {
                // This is of the form '$5.00'
                var offerValue = $scope.evaluateCheckoutOfferEligibilityModel.getOfferValue();

                $scope.incentiveAmount = offerValue;

                var currencyCode = $scope.evaluateCheckoutOfferEligibilityModel.getCurrencyCode();
                var precisionDigits = _squid.$locale.metadata.currency.digits[currencyCode];

                if (precisionDigits) {
                    var decimalDigitsStr = offerValue.substring(offerValue.length - precisionDigits);
                    var areAllDecimalDigitsZeroes = /^0*$/.test(decimalDigitsStr);

                    if (areAllDecimalDigitsZeroes) {
                        // Remove trailing decimals and punctuation
                        $scope.incentiveAmount = offerValue.substring(0, offerValue.length - precisionDigits - 1);
                    }
                }

                // Don't show incentive terms by default
                $scope.showIncentiveTerms = false;

                $scope.toggleShowIncentiveTerms = function () {
                    $scope.showIncentiveTerms = !$scope.showIncentiveTerms;
                };
            }

            // Show selectFi features if no contingency
            if (selectFiVariant && !message && !(subscriptionAuRMGElmoResult.enabled === true && isGamblingMerchant)) {
                $scope.showCancel = checkAvailableFI() ? true : false;
                $scope.parentState = 'checkout.selectFi';
                $scope.pagetitle = _squid.$locale.content.get('addCard.addACard');
            }
        });

        $scope.isAddCardContingency = function () {
            return _uiRouter.$stateParams.message === 'NEED_CREDIT_CARD';
        };

        $scope.isUpdateDebitCard = function () {
            return _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD';
        };
    }]
});

angular.value("$xoPageAddCardPageComponent", $xoPageAddCardPageComponent);
_angular.$q;

_angular.$rootScope;

_angular.noop;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_squid.$Component;

_squid.$config;

_squid.$locale;

_squid.$populate;

_squid.$promise;

_squid.$renderContent;

_squid.$util;

_squid.formatNameInformal;

_squid.$elmo;

_factory.$NoBalanceFactory;

_factory2.$AddCardFactory;

_auth.$AuthModel;

_fi.$UnavailableCardModel;

_choice.$ChoiceEligibility;

_app.$TokenizedWalletPinModel;

_fiMessages.$fiMessages;

_newMember.$NewMemberEligibility;

_checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel;

_checkoutIncentive.$GetOfferProgramModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutPayeeModel;

_checkout.$CheckoutSessionModel;

_factory3.$ExpiredFiPanelFactory;

_sharedUtil.$SharedUtil;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-card/directive.js
// module id = ./pages/xo-add-card/directive.js
// module chunks = 0